module.exports = __webpack_public_path__ + "media/correctGuess.afc6e2c3.wav";